@if(utenteProvisioningFormGroup){
  <form [formGroup]="utenteProvisioningFormGroup">
    <div class="row g-3">
      <div class="col-12 col-lg-6">
        <it-input label="Nome" type="text" formControlName="nome" #nome>
          <ng-container error>
            @if (nome.hasError('required')) {
              <div>Il campo è obbligatorio</div>
            }
            @if (!nome.hasError('required') && nome.hasError('whitespace')) {
              <div>Il campo non è valido</div>
            }
            @if (nome.hasError('maxlength')) {
              <div>Limite caratteri superato</div>
            }
          </ng-container>
        </it-input>
      </div>
      <div class="col-12 col-lg-6">
        <it-input label="Cognome" type="text" formControlName="cognome" #cognome>
          <ng-container error>
            @if (cognome.hasError('required')) {
              <div>Il campo è obbligatorio</div>
            }
            @if (!cognome.hasError('required') && cognome.hasError('whitespace')) {
              <div>Il campo non è valido</div>
            }
            @if (cognome.hasError('maxlength')) {
              <div>Limite caratteri superato</div>
            }
          </ng-container>
        </it-input>
      </div>
      <div class="col-12 col-lg-6">
        <it-select label="Sesso" formControlName="sesso" defaultOption="Seleziona..." #sesso>
          <option value="M">Maschile</option>
          <option value="F">Femminile</option>
          <ng-container error>
            @if (sesso.hasError('required')) {
              <div>Il campo è obbligatorio</div>
            }
          </ng-container>
        </it-select>
      </div>
      <div class="col-12 col-lg-6">
        <it-input label="Data di nascita" type="date" [minDate]="minDate" [maxDate]="today" formControlName="dataNascita" #dataNascita>
          <ng-container error>
            @if (dataNascita.hasError('required')) {
              <div>Il campo è obbligatorio</div>
            }
          </ng-container>
        </it-input>
      </div>
      <div class="col-12 col-lg-6">
        <it-autocomplete
          label="Luogo di nascita"
          placeholder="Cerca..."
          formControlName="luogoNascita"
          [autocompleteData]="autocompleteUsers$"
          (autocompleteSelectedEvent)="onAutocompleteSelected($event)">
          <ng-container error>
            @if (luogoNascita.hasError('required')) {
              <div>Il campo è obbligatorio</div>
            }
            @if (luogoNascita.hasError('error')) {
              <div>Il campo non è valido</div>
            }
          </ng-container>
        </it-autocomplete>
      </div>
      <div class="col-12 col-lg-6">
        <it-input label="Codice fiscale" type="text" formControlName="codiceFiscale" #codiceFiscale>
          <ng-container error>
            @if (codiceFiscale.hasError('required')) {
              <div>Il campo è obbligatorio</div>
            }
            @if (!codiceFiscale.hasError('required') && codiceFiscale.hasError('whitespace')) {
              <div>Il campo non è valido</div>
            }
            @if (codiceFiscale.hasError('pattern')) {
              <div>Il campo non è valido</div>
            }
          </ng-container>
        </it-input>
      </div>
      <div class="col-12 col-lg-6">
        <it-input label="Email" type="text" formControlName="email" #email>
          <ng-container error>
            @if (email.hasError('required')) {
              <div>Il campo è obbligatorio</div>
            }
            @if (!email.hasError('required') && email.hasError('pattern')) {
              <div>Il campo non è valido</div>
            }
            @if (email.hasError('maxlength')) {
              <div>Limite caratteri superato</div>
            }
          </ng-container>
        </it-input>
      </div>
      <div class="col-12 col-lg-6">
        <it-input label="Conferma email" type="text" formControlName="confermaEmail" #confermaEmail>
          <ng-container error>
            @if (confermaEmail.hasError('required')) {
              <div>Il campo è obbligatorio</div>
            }
            @if (!confermaEmail.hasError('required') && confermaEmail.hasError('pattern')) {
              <div>Il campo non è valido</div>
            }
            @if (confermaEmail.hasError('maxlength')) {
              <div>Limite caratteri superato</div>
            }
            @if (confermaEmail.hasError('emailMatch')) {
              <div>L'indirizzo email non corrisponde</div>
            }
          </ng-container>
        </it-input>
      </div>
      @if (telefono) {
      <div class="col-12 col-lg-6">
        <it-input label="Telefono" type="text" formControlName="telefono" #telefono>
          <ng-container error>
            @if (telefono.hasError('required')) {
              <div>Il campo è obbligatorio</div>
            }
            @if (!telefono.hasError('required') && telefono.hasError('whitespace')) {
              <div>Il campo non è valido</div>
            }
            @if (telefono.hasError('maxlength')) {
              <div>Limite caratteri superato</div>
            }
            @if (telefono.hasError('pattern')) {
              <div>Il campo non è valido</div>
            }
          </ng-container>
        </it-input>
      </div>
      }
      @if (unitaOrganizzative) {
        <div class="col-12 col-lg-6">
          <it-select label="Unità Organizzative" formControlName="unitaOrganizzative" defaultOption="Seleziona..." #unitaOrganizzative>
            @for (unita of uoList; track $index) {
              <option value="{{unita.idUnitaOrganizzativa}}">
                {{unita.descrizione}}</option>
            }
            <ng-container error>
              @if (unitaOrganizzative.hasError('required')) {
                <div>Il campo è obbligatorio</div>
              }
            </ng-container>
          </it-select>
        </div>
        }
        @if (ruoliUtente) {
          <div class="col-12 col-lg-6">
            <it-select label="Ruoli Utente" formControlName="ruoliUtente" defaultOption="Seleziona..." #ruoliUtente>
              @for (ruolo of ruoliList; track $index) {
                <option value="{{ruolo.idRuolo}}">{{ruolo.descrizione}}</option>
              }
              <ng-container error>
                @if (ruoliUtente.hasError('required')) {
                  <div>Il campo è obbligatorio</div>
                }
              </ng-container>
            </it-select>
          </div>
        }
    </div>
  </form>
  }
